export const setupErrorHandling = () => {
  // Intercepter les erreurs globales
  window.addEventListener('error', (event) => {
    console.error('Erreur globale:', event.error);
    
    // Ignorer les erreurs de syntaxe dans les scripts externes (comme clear-sw-cache.js)
    if (event.error && event.error.message && event.error.message.includes('Unexpected token')) {
      console.warn('Erreur de syntaxe ignorée dans script externe:', event.filename);
      return;
    }
    
    // Afficher un message d'erreur utilisateur-friendly
    if (document.getElementById('root')) {
      const root = document.getElementById('root');
      // Vérifier si l'erreur n'est pas déjà affichée
      if (!root.querySelector('.error-fallback')) {
        root.innerHTML = `
          <div class="error-fallback" style="padding: 2rem; text-align: center; font-family: system-ui, sans-serif;">
            <h2 style="color: #dc2626; margin-bottom: 1rem;">Erreur de chargement</h2>
            <p style="color: #4b5563; margin-bottom: 1.5rem;">L'application rencontre un problème technique.</p>
            <button 
              onclick="window.location.reload()" 
              style="background: #2563eb; color: white; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer; font-size: 0.875rem;"
            >
              Recharger l'application
            </button>
            <p style="color: #9ca3af; font-size: 0.75rem; margin-top: 1rem;">
              Si le problème persiste, contactez le support technique.
            </p>
          </div>
        `;
      }
    }
  });

  // Intercepter les promesses rejetées
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Promesse rejetée:', event.reason);
    
    // Pour les erreurs réseau ou Firebase, on peut afficher un message plus spécifique
    if (event.reason && event.reason.message) {
      if (event.reason.message.includes('network') || event.reason.message.includes('Network')) {
        console.warn('Erreur réseau détectée');
      }
      if (event.reason.message.includes('firebase') || event.reason.message.includes('Firebase')) {
        console.warn('Erreur Firebase détectée');
      }
    }
  });

  // Intercepter les erreurs de ressources (images, CSS, etc.)
  window.addEventListener('error', (event) => {
    if (event.target && event.target.tagName) {
      console.warn(`Erreur de chargement de ressource: ${event.target.tagName}`, event.target.src || event.target.href);
    }
  }, true);
};

// Fonction pour afficher une erreur utilisateur-friendly
export const showUserError = (message = 'Une erreur est survenue') => {
  if (document.getElementById('root')) {
    const root = document.getElementById('root');
    root.innerHTML = `
      <div class="user-error" style="padding: 2rem; text-align: center; font-family: system-ui, sans-serif;">
        <h2 style="color: #dc2626; margin-bottom: 1rem;">Erreur</h2>
        <p style="color: #4b5563; margin-bottom: 1.5rem;">${message}</p>
        <button 
          onclick="window.location.reload()" 
          style="background: #2563eb; color: white; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer; font-size: 0.875rem;"
        >
          Recharger
        </button>
      </div>
    `;
  }
};

// Fonction pour vérifier la connectivité
export const checkConnectivity = async () => {
  try {
    const response = await fetch('/favicon.ico', { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    return false;
  }
};
